"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var React = require("react");
var Page = function (_a) {
    var id = _a.id, children = _a.children;
    return (React.createElement("div", { id: id, className: "page" }, children));
};
exports.Page = Page;
